import React, { useEffect, useState } from 'react';
import { PageError, PageErrorType } from 'pages/page-error';
import { Loading } from 'components/block/loading';
import { Outlet } from 'react-router-dom';
import Footer from './footer';
import Sidebar from './sidebar';
import Header from './header';
import { ModalContainer } from 'services/modal';
import { getListMasterData } from 'services/master-data';
import { useSubscription } from 'hooks/use-subscription.hook';
// import { tmpSeedingUser } from 'api/chat/pairing.api';

enum Initializing {
  OK,
  RUNNING,
  FAIL,
}

export default function NormalLayout() {
  const [initializing, setInitializing] = useState<Initializing>(Initializing.RUNNING);
  const [isCheckCollapse, setIsCheckCollapse] = useState(false);
  const [clientWidth, setClientWidth] = useState<number>(window.innerWidth);

  const subscription = useSubscription();

  useEffect(() => {
    addEventListener('resize', () => {
      setClientWidth(document.body.clientWidth);
    });

    return () => {
      window.removeEventListener('resize', () => {
        setClientWidth(document.body.clientWidth);
      });
    };
  }, []);

  useEffect(() => {
    // tmpSeedingUser().subscribe();
    getListMasterData(['masterData']).subscribe({
      next: () => {
        setInitializing(Initializing.OK);
      },
      error: () => setInitializing(Initializing.FAIL),
    });
  }, [subscription]);

  if (initializing === Initializing.RUNNING) {
    return <Loading />;
  }

  if (initializing === Initializing.FAIL) {
    return <PageError error={PageErrorType.APP_LOAD_FAILED} />;
  }

  return (
    <div className='wrapper'>
      <Header setIsCheckCollapse={setIsCheckCollapse} clientWidth={clientWidth} />

      <Sidebar isCheckCollapse={isCheckCollapse} clientWidth={clientWidth} />

      <Outlet />

      <Footer />

      <ModalContainer />
    </div>
  );
}
